import { render, staticRenderFns } from "./PairTime.vue?vue&type=template&id=3bdc312c"
import script from "./PairTime.vue?vue&type=script&lang=js"
export * from "./PairTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports